import React from 'react';
import {
  format,
  differenceInDays,
} from 'date-fns';
import {
  InfoText,
  StatusInfoContainer,
  DateInfoText,
  RemainingDaysContainer,
  RemainingDaysTitle,
  RemainingDaysValue,
  RemainingDaysContainerRow,
  RemainingDaysInfo,
  RemainingDaysValueBackground,
} from './styles';
import { VirtualRaceType } from '../../types/VirtualRace';

interface Props {
  virtualRace: VirtualRaceType,
}

export default function VirtualRaceWaiting({ virtualRace }: Props) {
  const startDate = new Date(virtualRace.startDate);
  const endDate = new Date(virtualRace.endDate);
  const currentDate = new Date();

  startDate.setHours(0, 0, 0, 0);
  currentDate.setHours(0, 0, 0, 0);

  const daysUntilStart = differenceInDays(startDate, currentDate);
  const daysRemaining = daysUntilStart > 0 ? daysUntilStart : 0;
  const daysUntilStartFormatted = String(daysRemaining).padStart(2, '0');
  const daysArray = daysUntilStartFormatted.split('');
  const daysText = daysRemaining === 1 ? 'Dia para a prova!' : 'Dias para a prova!';
  const faltamText = daysRemaining === 1 ? 'Falta' : 'Faltam';

  return (
    <>
      <StatusInfoContainer>
        <RemainingDaysContainer>
          <RemainingDaysTitle>{faltamText}</RemainingDaysTitle>
          <RemainingDaysContainerRow>
            {daysArray.map((day, index) => (
              <RemainingDaysValueBackground key={index}>
                <RemainingDaysValue>{day}</RemainingDaysValue>
              </RemainingDaysValueBackground>
            ))}
          </RemainingDaysContainerRow>
          <RemainingDaysInfo>{daysText}</RemainingDaysInfo>
        </RemainingDaysContainer>
        <DateInfoText>PERÍODO DE REGISTRO DE ATIVIDADES</DateInfoText>
        <InfoText>
          {`De ${format(startDate, 'dd/MM')} a ${format(endDate, 'dd/MM')}`}
        </InfoText>
      </StatusInfoContainer>
    </>
  );
}
